import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Motion, spring } from 'react-motion';

import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';

import DeleteIcon from '@material-ui/icons/Delete';

import primaryColor from '@material-ui/core/colors/grey';
import green from '@material-ui/core/colors/green';

import InvoiceHeader from './Invoice/InvoiceHeader';
import InvoiceItem from './Invoice/InvoiceItem';
import InvoicePayments from './Invoice/InvoicePayments';
import InvoicePreview from './Invoice/InvoicePreview';

import { startEditAdmin } from '../../store/actions/admin';
import {
  startEditLineItem,
  startEditInvoice,
  startRemoveLineItem,
  startEditInvoiceStatuses
} from '../../store/actions/invoices';

const lightGreen = green[200];

const styles = theme => ({
  root: {
    margin: '20px'
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: primaryColor[100]
  },
  footer: {
    height: '20px',
  },
  headerTitle: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  headerContent: {
    padding: '10px 30px 60px 30px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  address: {
    display: 'flex',
    flexDirection: 'column'
  },
  addressSpacer: {
    height: '20px',
  },
  detail: {
    padding: '10px',
    marginTop: theme.spacing.unit * 5,
    marginBottom: theme.spacing.unit * 5,
  },
  totals: {
    padding: '30px 30px 50px 0px',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  totalsBalance: {
    paddingRight: '25px',
  },
  button: {
    margin: theme.spacing.unit,
  },
  doneIcon: {
    paddingLeft: '5px',
  },
  deleteButton: {
    width: '10px',
    margin: theme.spacing.unit,
  },
  textFieldRoot: {
    padding: 0,
    'label + &': {
      marginTop: theme.spacing.unit * 3,
    },
  },
  textFieldInput: {
    borderRadius: 4,
    backgroundColor: theme.palette.common.white,
    fontSize: 16,
    padding: '10px 12px',
    width: 'calc(100% - 24px)',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:focus': {
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
  labelField: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
  checked: {
    color: lightGreen,
  },
  tableCell: {
    minWidth: '70px',
  }
});

//TODO:
//1. replace with a better way to navigate away from invoice page
//2. move props destructuring into the function
//3. bind dispatches to child components instead of passing down as props
class InvoicePage extends Component{
  constructor(props){
    super(props);
    this.state = {
      showPreview: false
    }
  }

  handlePreviewOpen = () => {
    window.scrollTo(0, 0);
    this.setState({showPreview: true});
  }

  handlePreviewClose = () => {
    this.setState({showPreview: false});
  }

  render(){
    const {
      classes,
      startEditAdmin,
      startEditLineItem,
      startEditInvoice,
      startRemoveLineItem,
      startEditInvoiceStatuses,
      invoice,
      client,
      business
    } = this.props;

    return(
      <Motion defaultStyle={{x: -20, y: -20, opacity: 0}}
              style={{
                x: spring(0),
                y: spring(0),
                opacity: spring(1, { stiffness:30, damping: 10})
              }}>
        {(style) => (
          <div style={{
                  transform: `translate(${style.x}px, ${style.y}px)`,
                  opacity: style.opacity
                }}>
            <InvoicePreview
              invoice={invoice}
              showPreview={this.state.showPreview}
              handleClose={this.handlePreviewClose}
            />
            <Card className={classes.root}>
              <InvoiceHeader
                invoice={invoice}
                client={client}
                business={business}
                startEditAdmin={startEditAdmin}
                startEditInvoice={startEditInvoice}
                startEditInvoiceStatuses={startEditInvoiceStatuses}
                handlePreviewOpen={this.handlePreviewOpen.bind(this)}
              />
              <InvoicePayments invoice={invoice} />
              <InvoiceDetail classes={classes} invoice={invoice} startEditLineItem={startEditLineItem} startRemoveLineItem={startRemoveLineItem} />
              <InvoiceTotals classes={classes} invoice={invoice}/>
              <InvoiceFooter classes={classes}/>
            </Card>
          </div>
        )}
      </Motion>
    );
  }
}

//TODO: move InvoiceItem, InvoicePreview, and InvoicePayment to their respective parent components
class InvoiceDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showItem: undefined,
      lineItem: undefined,
      showPayment: undefined,
      payment: undefined
    }
  }

  handleEditOpen = () => {
    this.setState({showItem: "edit"});
  };

  handleAddOpen = () => {
    this.setState({showItem: "add"});
  };

  handleAddPayment() {
    this.setState({showPayment: "add"});
  }
  handleEditPayment() {
    this.setState({showPayment: "edit"});
  }

  handleClose = () => {
    this.setState({
      showItem: undefined,
      lineItem: undefined,
      showPayment: undefined,
      payment: undefined
    });
  };

  render(){
    const {classes, invoice, startEditLineItem, startRemoveLineItem} =this.props;
    //TODO: remove hack to convert Map to Array
    const lineItems = [];
    invoice.lineItems.forEach((lineItem, id) => {
      lineItems.push(Object.assign({}, {id}, lineItem));
    });

    return(
      <div className={classes.detail}>
        <InvoiceItem
          invoice={invoice}
          showItem={this.state.showItem}
          lineItem={this.state.lineItem}
          handleClose={this.handleClose}
        />
        <div>
          <Typography
            variant="subheading"
            style={{
              paddingTop: '0px',
              paddingLeft: '18px',
            }}>
            Line Items
          </Typography>
        </div>
        <Table style={{paddingLeft: '00px'}}>
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableCell} padding="checkbox" variant="head">Approved</TableCell>
              <TableCell className={classes.tableCell} padding="dense" variant="head">Date</TableCell>
              <TableCell className={classes.tableCell} padding="dense" variant="head">Description</TableCell>
              <TableCell className={classes.tableCell} padding="dense" variant="head" numeric>Quantity</TableCell>
              <TableCell className={classes.tableCell} padding="dense" variant="head" numeric>Unit Price</TableCell>
              <TableCell className={classes.tableCell} padding="dense" variant="head" numeric>Total</TableCell>
              <TableCell padding="none" variant="head" />
            </TableRow>
          </TableHead>
          <TableBody>
            {lineItems.length !== 0 &&
              lineItems.map((lineItem) => {
                return (
                  <TableRow
                    hover
                    key={lineItem.id}
                    style={{cursor: 'pointer'}}
                    >
                    <TableCell
                      padding="checkbox"
                      >
                      <Checkbox
                        checked={lineItem.approved}
                        classes={{
                           checked: classes.checked,
                         }}
                         onChange={ (event) => {
                           startEditLineItem(invoice.id, lineItem.id, {approved: !lineItem.approved})
                         }}
                      />
                    </TableCell>
                    <TableCell
                      padding="dense"
                      onClick={() => this.setState({showItem: "edit", lineItem: lineItem})}
                      >
                      <Moment format="MMM Do">{new Date()}</Moment>
                    </TableCell>
                    <TableCell
                      padding="dense"
                      variant="body"
                      style={{width: '80%'}}
                      onClick={() => this.setState({showItem: "edit", lineItem: lineItem})}
                      >
                      {lineItem.description}
                    </TableCell>
                    <TableCell
                      padding="dense"
                      variant="body"
                      numeric
                      onClick={() => this.setState({showItem: "edit", lineItem: lineItem})}
                      >
                      {lineItem.quantity}
                    </TableCell>
                    <TableCell
                      padding="dense"
                      variant="body"
                      numeric
                      onClick={() => this.setState({showItem: "edit", lineItem: lineItem})}
                      >
                        ${lineItem.unitPrice.toFixed(2)}
                    </TableCell>
                    <TableCell
                      padding="dense"
                      variant="body"
                      numeric
                      onClick={() => this.setState({showItem: "edit", lineItem: lineItem})}
                      >
                        ${lineItem.total.toFixed(2)}
                    </TableCell>
                    <TableCell padding="none" variant="body">
                      <Button
                        aria-label="delete"
                        size="small"
                        className={classes.deleteButton}
                        onClick={() => startRemoveLineItem(invoice.id, lineItem.id)}
                        style={{color: '#757de8'}}
                        >
                        <DeleteIcon />
                      </Button>
                    </TableCell>
                  </TableRow>
                );
            })}
          </TableBody>
        </Table>
        <Button
          color="primary" className={classes.button}
          onClick={this.handleAddOpen}>
          Add Item
        </Button>
      </div>
    );
  }
}

const InvoiceTotals = ({classes, invoice}) =>
  <div className={classes.totals}>
    <div>
      <div className={classes.labelField}>
        <Typography variant="subheading">Subtotal:&nbsp;&nbsp;</Typography>
        <Typography variant="subheading">${invoice.total.toFixed(2)}</Typography>
      </div>
      <div className={classes.labelField}>
        <Typography variant="subheading">GST:&nbsp;&nbsp;</Typography>
        <Typography variant="subheading">${invoice.gst.toFixed(2)}</Typography>
      </div>
      <div className={classes.labelField}>
        <Typography variant="subheading">PST:&nbsp;&nbsp;</Typography>
        <Typography variant="subheading">${invoice.pst.toFixed(2)}</Typography>
      </div>
      <hr />
      <div className={classes.labelField}>
        <Typography className={classes.totalsBalance} variant="subheading">Total:</Typography>
        <Typography variant="subheading">${invoice.grandTotal.toFixed(2)}</Typography>
      </div>
      <div className={classes.labelField}>
        <Typography className={classes.totalsBalance} variant="subheading">Payments:</Typography>
        <Typography variant="subheading">${invoice.paymentTotal.toFixed(2)}</Typography>
      </div>
      <hr />
      <hr />
      <div className={classes.labelField}>
        <Typography className={classes.totalsBalance} variant="title">Balance:</Typography>
        <Typography variant="title">${invoice.balance.toFixed(2)}</Typography>
      </div>
    </div>
  </div>


const InvoiceFooter = ({classes}) =>
  <div className={classes.footer}></div>

InvoicePage.propTypes = {
  classes: PropTypes.object.isRequired,
}


const mapStateToProps = (state) => {
  const invoice = state.invoicesState.find( invoice => invoice.id === state.adminState.invoice.id );
  const project = invoice.projectId === undefined
    ? undefined
    : state.projectsState.find(project => project.id === invoice.projectId);

  let client = invoice.clientId === undefined
    ? undefined
    : state.clientsState.find(client => client.id === invoice.clientId);

  if (client === undefined && project !== undefined) {
    client = state.clientsState.find(client => client.id === project.clientId);
  }

  return({
    invoice: invoice,
    client: client,
    business: state.businessState
  });

};

const mapDispatchToProps = (dispatch) => ({
  startEditAdmin: (invoice) => dispatch(startEditAdmin(invoice)),
  startEditLineItem: (invoiceID, lineItemID, updates) => dispatch(startEditLineItem(invoiceID, lineItemID, updates)),
  startEditInvoice: (invoiceID, invoice) => dispatch(startEditInvoice(invoiceID, invoice)),
  startRemoveLineItem: (invoiceID, lineItemID) => dispatch(startRemoveLineItem(invoiceID, lineItemID)),
  startEditInvoiceStatuses: (invoiceID, statuses) => dispatch(startEditInvoiceStatuses(invoiceID, statuses))
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(InvoicePage);



// WEBPACK FOOTER //
// ./src/components/admin/Invoice.jsx